import { restApi } from '../../../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { paginate } from '../../../../lib/loopback'
import { createQueryString } from '../../../../utils/Repository'

const queryTransform = {
  ...paginate
}

const pessoaFisicaRepository = createRepository({
  path: 'pessoas-fisica-rf',
  restApi,
  queryTransform: {
    ...paginate
  }
})

pessoaFisicaRepository.manualFetch = ({ solicitacaoId, cpf }) =>
  restApi.post(`/pessoas-fisica-rf/manual-fetch/${solicitacaoId}`, {
    cpf
  })

pessoaFisicaRepository.list = ({ query, paginate, options } = {}) => {
  const queryString = createQueryString(query, paginate, queryTransform)
  return restApi.get('/pessoas-fisica-rf' + queryString, {}, options)
}

export default pessoaFisicaRepository
